import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { StatisticState } from './types';
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

export const state: StatisticState = {
    callStatisticDetail: null,
    callStatisticDetailFlag: '',
    callStatisticDetailIncoming: [],

    callStatisticGroup: [],
    callStatisticGroupMessageCount: undefined,
    callStatisticGroupIncoming: [],
    callStatisticGroupIncomingMessageCount: undefined,
    callGroupings: {
        callGroup: [
            'hour',
            'day',
            'week',
            'month',
        ],
        callGroupByOptionally: [
            'partner',
            'service_provider',
            'originator',
            'operator',
            'template_id',
            'bulk_id',
            'broker_account_login',
            'message_type',
        ],
        callGroupByIncoming: [
            'hour',
            'day',
            'week',
            'month',
        ],
        callGroupByOptionallyIncoming: [
            'partner',
            'recipient',
            'operator',
        ]
    },
};


export const callStatistic: Module<StatisticState, RootState> = {
    state,
    getters,
    actions,
    mutations
};
